// @ts-nocheck
import {useEffect, useRef} from "react";

import {BaseBreadcrumb} from "@/components";
import LoadingLogo from "../../../components/LoadingLogo";
import {useMiniGames} from "../../../store/useMiniGames";

const LiveCasino = () => {
  const provider = "pragmatic";
  const gameId = 101;

  const getConfig = useMiniGames(state => state.getConfig);
  const gameUrl = useMiniGames(state => state.gameUrl);
  const loading = useMiniGames(state => state.loading);
  const error = useMiniGames(state => state.error);

  const iFrameRef = useRef(null);

  useEffect(() => {
    getConfig(provider, gameId);
  }, []);

  useEffect(() => {
    if (iFrameRef.current) {
      iFrameRef.current.focus(); // Set focus when the iframe loads
      iFrameRef.current.scrollIntoView({behavior: "smooth", block: "center"});
    }

    // hide bottom nav menu
    const bottomNavMenu = document.querySelector(".bottomNavMenu");
    if (bottomNavMenu) {
      bottomNavMenu.style.visibility = "hidden";
    }

    return () => {
      const bottomNavMenu = document.querySelector(".bottomNavMenu");
      if (bottomNavMenu) {
        bottomNavMenu.style.visibility = "visible";
      }
    };
  }, [gameUrl]); // Trigger the effect when gameUrl changes

  const headerHeight = document.querySelector("header")?.offsetHeight || 0; // Get header height

  return (
    <>
      <div className="px-4 pt-3">
        <BaseBreadcrumb items={[{label: "Casino en vivo"}]} />
      </div>
      <div style={{justifyContent: "center", alignItems: "center", minHeight: "100vh"}}>
      {error && <h3>We had an issue loading the game.</h3>}
      {loading || !gameUrl ? (
        <LoadingLogo />
      ) : (
        <iframe
          ref={iFrameRef}
          src={gameUrl}
          title="Live casino game"
          frameBorder="0"
          style={{
            width: "100%",
            height: `calc(100vh - ${headerHeight}px)`, // Subtract both footer and header heights
          }}
        />
      )}
    </div>
    </>
  );
};

export default LiveCasino;
